import { validationCheckFields } from './validationFields'
import ExpandedRowDetails from '../Shared/ExpandedRowDetails'

/**
 * ExpandedRow wrapper for GroupToBusinessRoleGrid (Type 5)
 * Uses the common ExpandedRow component with type-specific validation fields
 * and enables processStatus check
 */
export default function ExpandedRow({ data }) {
    return (
        <ExpandedRowDetails
            data={data}
            validationCheckFields={validationCheckFields}
            shouldCheckProcessStatus={true}
        />
    )
}
